import React, { useState, useEffect } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import * as XLSX from 'xlsx/xlsx.mjs';
import { notification } from '../../component/hocs/notification';

import { Row, Col, Card, CardBody, CardHeader, Button, Form, Input, Label, InputGroup, InputGroupText } from 'reactstrap';
import { FaEye, FaEdit, FaPlusCircle, FaClipboardList, FaFileExcel, FaSearch } from 'react-icons/fa';
import { MdDeleteForever } from 'react-icons/md';
import { RiFileExcel2Line } from "react-icons/ri";

import ViewFarmer from '../../component/utility/master/ViewFarmer';
import AddFarmer from '../../component/utility/master/AddFarmer';
import EditFarmer from '../../component/utility/master/EditFarmer';
import DeleteFarmer from '../../component/utility/master/DeleteFarmer';
import { mainurl } from '../../Mainurl';


const Farmer = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState('');
    const [filterData, setFilterData] = useState('');
    const [f_data, setF_Data] = useState('');
    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState(null);

    const [attachment, setAttachment] = useState('');

    //
    const [state, setState] = useState('0');
    const [stateOpt, setStateOpt] = useState('');
    const [district, setDistrict] = useState('0');
    const [districtOpt, setDistrictOpt] = useState('');
    const [block, setBlock] = useState('0');
    const [blockOpt, setBlockOpt] = useState('');
    const [village, setVillage] = useState('0');
    const [villageOpt, setVillageOpt] = useState('');



    function toggle() {
        setDisplayConfirmationModal(!displayConfirmationModal);
    }

    const farmer_list = () => {

        if (state == "0") {
            let notify = notification({ message: "Please select state!", type: 'error' });
            notify();
            return false;
        }
        setTableData([]);
        setFilterData([]);
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "state_id": state, }];
        axios({
            method: 'post',
            url: mainurl + 'Farmer/box_farmer_list2',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {

                    return (
                        {
                            ids: index + 1,
                            name: row.f_name + " (" + row.f_reg_no + ")",
                            mobile: row.mobile_no,
                            spouse_name: row.f_spouse_name,
                            location: row.state_name + "/" + row.district_name + "/" + row.block_name + "/" + row.village_name,
                            action: <div>
                                <FaEye className='me-3 cursor' color="#FFC000" size={20} onClick={() => view_handler(row)} />
                                <FaEdit className='me-3 cursor' color="#006600" size={20} onClick={() => edit_handler(row)} />
                                <MdDeleteForever className='cursor' color="#f70000" size={20} onClick={() => delete_handler(row.f_name, row.farmer_code)} />
                            </div>
                        }
                    )
                });

                setTableData(list);
                setFilterData(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }

    // filter
    const filter_data_handler = (e) => {
        const safeLower = val => (val ?? '').toString().toLowerCase();
        let filterData = tableData.filter(item => {
            const query = safeLower(e.target.value);

            return [
                item.name,
                item.mobile,
                item.spouse_name,
                item.location,
            ].some(val => safeLower(val).includes(query));
        });
        setFilterData(filterData);

    }

    const view_handler = (data) => {
        setF_Data(data);
        setMode(3);
    }

    const edit_handler = (data) => {
        setF_Data(data);
        setMode(4);
    }

    function delete_handler(farmerName, farmerCode) {
        setDeleteMsg(`Confirm Delete ${farmerName} [code:${farmerCode}] ?`);
        toggle();
    }

    const back_handler = () => {
        setMode(1);
    }

    const file_upload_handler = (e) => {
        let temp = [];
        for (let i = 0; i < e.target.files.length; i++) {
            temp.push(e.target.files[i]);
        }
        setAttachment([...temp]);
    }

    const upload_excel_farmer = (e) => {
        e.preventDefault();

        console.log(attachment[0]);
        let formData = new FormData();
        formData.append("file", attachment[0]);

        axios({
            method: 'post',
            url: mainurl + 'farmer_upload/upload_farmer_excel',
            data: formData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (response.data[0].json_status == "success") {
                    let notify = notification({ message: response.data[0].message, type: 'success' });
                    notify();
                    setMode(1);

                } else {
                    let notify = notification({ message: "Failed, Try again", type: 'error' });
                    notify();
                }
                console.log(response.data);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });

    }

    useEffect(() => {
        get_state_list();
    }, []);
    //
    const get_state_list = (e) => {

        let postData = [{ "country_code": "1", "user_id": sessionStorage.getItem('user_id') }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list2',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.state_code}> {row.state_name}</option>
                    )
                });

                setStateOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }

    const get_dist_list = (e) => {
        setState(e.target.value);
        let postData = [{ "state_code": e.target.value }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_dist_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.district_code}> {row.district_name}</option>
                    )
                });

                setDistrictOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }

    const get_block_list = (e) => {
        setDistrict(e.target.value);
        let postData = [{ "dist_code": e.target.value }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_block_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.block_code}> {row.block_name}</option>
                    )
                });

                setBlockOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }
    const get_village_list = (e) => {
        setBlock(e.target.value);

        let postData = [{ "block_code": e.target.value }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_village_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.village_code}> {row.village_name}</option>
                    )
                });

                setVillageOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }
    //

    const download_excel_handler = () => {
        let ExcelData = [
            {
                "f_id": 1,
                "f_name": '',
                "f_gurdian_name": '',
                "age": '',
                "dob": '',
                "mobile_no": '',
                "aadhar_no": '',
                "gender": '',
                "Category": '',
                "No_of_family_members": '',
                "f_reg_no": '',
                "f_id_serial": '',
                "state_id": state,
                "district_id": district,
                "block_id": block,
                "village_id": village,
            },
            {
                "f_id": 2,
                "f_name": '',
                "f_gurdian_name": '',
                "age": '',
                "dob": '',
                "mobile_no": '',
                "aadhar_no": '',
                "gender": '',
                "Category": '',
                "No_of_family_members": '',
                "f_reg_no": '',
                "f_id_serial": '',
                "state_id": state,
                "district_id": district,
                "block_id": block,
                "village_id": village,
            },
        ]
        if (ExcelData.length > 0) {
            let wb = XLSX.utils.book_new(),
                ws = XLSX.utils.json_to_sheet(ExcelData);
            XLSX.utils.book_append_sheet(wb, ws, "Mysheet1");
            XLSX.writeFile(wb, "farmer_upload_excel.xlsx");
            let notify = notification({ message: "Excel downloaded successfully", type: 'success' });
            notify();
        } else {
            let notify = notification({ message: "No data found!", type: 'error' });
            notify();
        }
    }


    return (
        <>
            <Header />
            <Page title='Farmer' breadcrumbs='Home / Farmer'>
                <Row className='p-3'>
                    {mode === 1 &&
                        <Col xs={12}>
                            <Card className='mb-3' color="primary" outline>
                                <CardBody>
                                    <Row>
                                        <Col sm={3} className="mb-2">
                                            <Label for="state"> State </Label>
                                            <Input id="state" bsSize="sm" type="select" value={state} onChange={(e) => setState(e.target.value)} required>
                                                <option value="0"> --Select State--</option>
                                                {stateOpt}
                                            </Input>
                                        </Col>
                                        <Col md={2}>
                                            <Button className='text-white mt-4' color='primary' size="sm" block onClick={farmer_list}>
                                                <FaClipboardList className='me-1' size={20} />
                                                Get Farmer List
                                            </Button>
                                        </Col>
                                        <Col md={2}>
                                            <Button className='text-white mt-4' color='primary' size="sm" block onClick={() => setMode(2)}>
                                                <FaPlusCircle className='me-1' size={20} />
                                                Add New Farmer
                                            </Button>
                                        </Col>
                                        <Col md={3}>
                                            <Button className='text-white mt-4' color='primary' size="sm" block onClick={() => setMode(5)}>
                                                <FaFileExcel className='me-1' size={20} />
                                                Upload New Farmers (Excel)
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card className='' color="primary" outline>
                                <CardBody>
                                    <Row>
                                        <Col sm="12" className="mb-2">
                                            <InputGroup>
                                                <InputGroupText>
                                                    <FaSearch />
                                                </InputGroupText>
                                                <Input size="sm" type="text" placeholder='Search' onChange={filter_data_handler} />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    <DataTable
                                        title=""
                                        customStyles={custTableStyles}
                                        columns={[
                                            {
                                                name: 'Id',
                                                selector: row => row.ids,
                                                sortable: true,
                                                width: '80px'
                                            },
                                            {
                                                name: 'Name',
                                                selector: row => row.name,
                                                sortable: false,
                                                width: "20%",
                                                wrap: true
                                            },
                                            {
                                                name: 'Mobile Number',
                                                selector: row => row.mobile,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Spouse Name',
                                                selector: row => row.spouse_name,
                                                sortable: false,
                                                wrap: true
                                            },
                                            {
                                                name: 'Location',
                                                selector: row => row.location,
                                                sortable: false,
                                                width: "25%",
                                                wrap: true
                                            },
                                            {
                                                name: 'Action',
                                                selector: row => row.action,
                                                sortable: false,
                                            },
                                        ]}
                                        data={filterData}
                                        highlightOnHover
                                        progressPending={loading}
                                        pagination
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    }

                    {mode === 2 &&
                        <Col xs={12}>
                            <AddFarmer back={() => back_handler()} />
                        </Col>
                    }
                    {mode === 3 &&
                        <Col xs={12}>
                            <ViewFarmer data={f_data} back={() => back_handler()} />
                        </Col>
                    }

                    {mode === 4 &&
                        <Col xs={12}>
                            <EditFarmer data={f_data} back={() => back_handler()} />
                        </Col>
                    }

                    {mode === 5 &&
                        <Col xs={12}>
                            <Card className='mb-2' color="primary" outline>
                                <CardHeader> Upload Farmer with Excel </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col sm={3} className="mb-2">
                                            <Label for="state"> State </Label>
                                            <Input id="state" bsSize="sm" type="select" value={state} onChange={get_dist_list} required>
                                                <option value="0"> --Select State--</option>
                                                {stateOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={3} className="mb-2">
                                            <Label for="district"> District </Label>
                                            <Input id="district" bsSize="sm" type="select" value={district} onChange={get_block_list} required>
                                                <option value="0"> --Select District--</option>
                                                {districtOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={3} className="mb-2">
                                            <Label for="block" > Block </Label>
                                            <Input id="block" bsSize="sm" type="select" value={block} onChange={get_village_list} required>
                                                <option value="0"> --Select Block--</option>
                                                {blockOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={3} className="mb-2">
                                            <Label for="village" > Village </Label>
                                            <Input id="village" bsSize="sm" type="select" value={village} onChange={(e) => setVillage(e.target.value)} required>
                                                <option value="0"> --Select Village--</option>
                                                {villageOpt}
                                            </Input>
                                        </Col>
                                        <Col xs={12} className="mb-2">
                                            <Button className='text-white' color='primary' size="sm" onClick={download_excel_handler} >
                                                Download Excel Sheet
                                            </Button>
                                        </Col>
                                    </Row>

                                    <hr />

                                    <Form onSubmit={upload_excel_farmer} >
                                        <Row>
                                            <Col xs={4} className="mb-2">
                                                <Input type="file" multiple={false} onChange={file_upload_handler} accept=".xlsx, .xls" required />
                                            </Col>
                                            <Col xs={4} className="mb-2">
                                                <Button className='text-white' color='primary' size="sm" block>
                                                    <FaFileExcel className='me-1' size={20} />
                                                    Upload Excel
                                                </Button>
                                            </Col>
                                        </Row>

                                    </Form>

                                </CardBody>
                            </Card>
                            <div className='text-end'>
                                <Button className='text-white' color='primary' size="sm" onClick={back_handler}> Back </Button>
                            </div>

                        </Col>
                    }

                </Row>

            </Page>
            <Footer />
            <DeleteFarmer showConfirmationModal={displayConfirmationModal} toggle={toggle} message={deleteMsg} />
        </>
    )

}

export default Farmer;